import React, { useState } from "react";
import { bem } from "../../helpers";
import Section from "../Section/Section";
import Tab from "./Tab";
import "./Tabs.scss";

const Tabs = (props) => {
  const { className, tabs } = props;
  const [activeTab, setActiveTab] = useState(tabs[0].value);

  function onClickTabItem(tabValue) {
    setActiveTab(tabValue);
    props.onChange && props.onChange(tabValue);
  }

  return (
    <div className={bem("tabs", "list", [], className)}>
      {tabs.map((tab) => {
        return (
          <Tab
            key={tab.label}
            className={tab.className && null}
            activeTab={activeTab}
            label={tab.label}
            value={tab.value}
            onClick={onClickTabItem}
          />
        );
      })}
    </div>
  );
};

export default Tabs;
